export class ManagedMaterialFetchError extends Error {
  constructor(
    public readonly status: number,
    public readonly providerErrorBody: string,
    message?: string,
  ) {
    super(message ?? `Control-plane material fetch failed: HTTP ${status} ${providerErrorBody}`);
    this.name = "ManagedMaterialFetchError";
  }
}
